import {MaterialModule} from "@modules/material.module";
import {AppCoreModule} from "@modules/app.core.module";
import {AppSharedModule} from "@modules/app-shared.module";
import {NgModule} from "@angular/core";

import {EditSingleSpaceComponent} from '@features/spaces/edit-single-space/edit-single-space.component';
import {EditSingleSpaceDefaultPricingComponent} from '@features/spaces/edit-single-space-default-pricing/edit-single-space-default-pricing.component';
import {ListSpacesComponent} from '@features/spaces/list-spaces/list-spaces.component';
import {ManageFloorPlanComponent} from '@features/spaces/manage-floor-plan/manage-floor-plan.component';
import {ManageSpacesComponent} from '@features/spaces/manage-spaces/manage-spaces.component';
import {CrudTableComponent} from "@ui-kit/webkit/components/crud-table/crud-table.component";
import {IndustrySelectComponent} from "@shared-components/industry-select/industry-select.component";

const components = [
  EditSingleSpaceComponent,
  EditSingleSpaceDefaultPricingComponent,
  ListSpacesComponent,
  ManageFloorPlanComponent,
  ManageSpacesComponent,
];

@NgModule({
  imports: [
    MaterialModule,
    AppCoreModule,
    AppSharedModule,
    CrudTableComponent,
    IndustrySelectComponent
  ],
  declarations: [...components],
  exports: [...components],
  providers: []
})
export class FeatureSpacesModule {
}
